import React, { useState, useCallback, useContext } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import { useDropzone } from "react-dropzone";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import { GetStudentDetails, UpdateBulkStudentStatus } from "../../ReusableComponents/NCLAdmin/CommonAPi";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { FaRegEdit, FaRegSave } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { IoCloseCircleOutline } from "react-icons/io5";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { useSelector } from "react-redux";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import { MdFileDownload } from "react-icons/md";
import { Row, Col } from "react-bootstrap";
const SBDeactivation = () => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const { SetLoad } = useContext(LoadContext);
    const [SFName, SetSFName] = useState("");
    const [ValidRecords, SetValidRecords] = useState();
    const [InValidRecords, SetInValidRecords] = useState();

    const [EditingRow, SetEditingRow] = useState(null);
    const [EditForm, SetEditForm] = useState({});

    const [FConformation, SetFConformation] = useState(false);

    const ActuallHeader = ["S.No", "Student ID"];
    const validateHeader = (headerRow, expectedHeader) => {
        return JSON.stringify(headerRow) === JSON.stringify(expectedHeader);
    };
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            alert("Only .xls and .xlsx files are allowed");
            return;
        }
        SetLoad(true);
        const file = acceptedFiles[0];
        SetSFName(file?.name);
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
            const isHeaderValid = validateHeader(headers, ActuallHeader);
            if (!isHeaderValid) {
                alert("Invalid header in Excel file. Please check the file and try again.");
                SetSFName("")
                SetLoad(false);
                return "";
            }
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            if (jsonData?.length > 25) {
                notify("A Maximum of 25 Students are allowed to deactivate.", "warning");
                SetSFName(""); SetLoad(false);
                return "";
            }

            const studentIds = jsonData.map((row) => String(row["Student ID"] ?? "").trim()).filter((id) => id !== "");
            if (studentIds?.length === 0) {
                notify("The file is empty, please fill the required data and upload", "warning");
                SetSFName(""); SetLoad(false);
                return "";
            }
            const InvalidIds = [];
            const ValidIds = [];
            const seenIds = new Set();
            // studentIds.forEach(async (id) => {
            for (const id of studentIds) {
                if (seenIds.has(id)) {
                    InvalidIds.push({ ID: id, error: "Duplicate Student ID in Excel", Duplicate: true, RowID: crypto.randomUUID() });
                    continue;
                }
                seenIds.add(id);
                try {
                    await studentIdSchema.validate(parseInt(id), { abortEarly: false });
                    ValidIds.push(id)
                } catch (err) {
                    console.log(`Invalid Student ID: ${id}`, err.errors);
                    InvalidIds.push({ ID: id, error: err.errors[0], RowID: crypto.randomUUID(), })
                }
                // });
            }
            const Finialvalid = [];
            const GSDetails = await GetStudentDetails(ValidIds?.join(","))
            GSDetails?.forEach((id) => {
                if (id.studentStatus === "Active") {
                    Finialvalid.push(id)
                }
                else {
                    InvalidIds.push({ ID: id?.studentId, error: id.studentStatus, Duplicate: true, RowID: crypto.randomUUID(), })
                }
            })
            SetValidRecords(Finialvalid);
            SetInValidRecords(InvalidIds);
            SetLoad(false);
        }
        reader.readAsArrayBuffer(file);
    })

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx",],
        },
        multiple: false,
    });
    const studentIdSchema = Yup.string()
        .required("Student ID is required")
        .matches(/^\d+$/, "Student ID must contain numbers only")
        .matches(/^\d{10}$/, "Student ID must contain exactly 10 digits");
    const InvalidColumns = [
        {
            name: "Student ID", selector: "ID", sortable: true,
            cell: (row) => row.RowID === EditingRow?.RowID ?
                <input type="number" className="Search p-1" value={EditForm?.ID}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,10}$/.test(value)) { HandleInputChange(value, "ID"); }
                    }} />
                : row.ID
        },

        { name: "Errors", selector: "error", cell: (row) => (<div style={{ color: "#FD3333" }}> {row?.error}</div>), },
        {
            name: "Action",
            cell: (row) => (
                row.RowID === EditingRow?.RowID ?
                    <div className="dflex JCCenter gap-1" >
                        <FaRegSave title="Save School Details" className="CPointer" style={{ color: "#624DE3" }} size={18} onClick={() => ValidateEditRecord()} />
                        <IoClose style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => SetEditingRow("")} />
                    </div>
                    :
                    <div className="dflex JCCenter gap-1" >
                        {!row?.Duplicate && <FaRegEdit title="Edit School Details" className="CPointer" style={{ color: "#624DE3" }} size={18} onClick={() => HandleEdit(row)} />}
                        <RiDeleteBin5Line style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => DeleteInvalidRecords(row)} />
                    </div>
            ),
        },
    ];
    const HandleInputChange = (e, field) => { SetEditForm((prev) => ({ ...prev, [field]: e, })); };
    const DeleteInvalidRecords = (row) => {
        SetInValidRecords((prev) => (prev || []).filter((record) => record !== row));
    }
    const DeleteValidRecords = (row) => {
        SetValidRecords((prev) => ((prev || []).filter((record) => record !== row)));
    }
    const HandleEdit = (row) => {
        SetEditingRow(row);
        SetEditForm({ ...row });
    };

    const ValidateEditRecord = async () => {
        SetLoad(true);
        try {
            await studentIdSchema.validate(parseInt(EditForm?.ID), { abortEarly: false });
            const existingSchool = (ValidRecords || []).find(
                (record) => String(record.studentId) === String(EditForm?.ID));
            if (existingSchool) {
                SetEditingRow("");
                SetEditForm({});
                SetInValidRecords((prev) => {
                    const remainingRecords = (prev || []).filter((record) => record !== EditingRow);
                    return [...remainingRecords,
                    { ...EditForm, Duplicate: true, error: "Duplicate Record", RowID: crypto.randomUUID() },];
                });
            } else {
                const GSDetails = await GetStudentDetails(String(EditForm?.ID ?? "").trim())
                GSDetails?.forEach((id) => {
                    if (id.studentStatus === "Active") {
                        SetInValidRecords((prev) => (prev || []).filter((record) => record !== EditingRow));
                        SetValidRecords((prev) => [...prev, id]);
                    }
                    else {
                        SetInValidRecords((prev) =>
                            (prev || []).map((record) =>
                                record.RowID === EditingRow?.RowID
                                    ? { ...record, ID: id?.studentId, error: id.studentStatus, Duplicate: true, RowID: crypto.randomUUID() }
                                    : record
                            )
                        );
                    }
                    SetEditingRow(null);
                    SetEditForm({});
                    SetLoad(false);
                })
            }
        } catch (err) {
            console.log("err", err)
            SetInValidRecords((prev) =>
                (prev || []).map((record) =>
                    record.RowID === EditingRow?.RowID
                        ? { ...record, ID: EditForm?.ID, error: err.errors[0], RowID: crypto.randomUUID() }
                        : record
                )
            );
            SetLoad(false);
        }
    }

    const handleDeactivate = async () => {
        SetLoad(true);
        const studentIds = ValidRecords.map((student) => String(student.studentId));
        const res = await UpdateBulkStudentStatus({ loginIds: studentIds?.map(String), modifiedBy: items?.userId, })
        if (res >= 1) {
            notify("Students were deactivated successfully.", "success");
            SetValidRecords();
            SetInValidRecords(); SetSFName("");
        } else if (res <= 0) {
            notify("The Students are not deactivated. Please try again after some time.", "error");
        }
        SetFConformation(false);
        SetLoad(false);
    }
    const DownloadSamplefile = () => {
        const a = document.createElement("a");
        a.href = `/StudentDeactivation.xlsx`;
        a.download = "StudentDeactivationTemplate.xls";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    return (
        <>
            <div className="dflex " style={{ justifyContent: "flex-end" }}>
                <div className="dflex alignitems gap-1 CPointer LinkStyles" onClick={() => DownloadSamplefile()}> <MdFileDownload />Download Template</div>
            </div>
            <Row className="Card mt-2">
                <Col>
                    <div className="SubHeading">Upload student Id's</div>
                    <div className="mt-2 dflex JCCenter alignitems flexd-column p-3">
                        <div className="dflex alignitems JCCenter gap-1">
                            <RiFileExcel2Fill fontSize={60} color="#107c41" />
                            <div
                                {...getRootProps()} className="CPointer dflex alignitems JCCenter p-2 w-100"
                                style={{
                                    border: "2px dashed #1436a5", textAlign: "center", borderRadius: "5px",
                                    backgroundColor: "#e0e7ff",
                                }} >
                                <input {...getInputProps()} />
                                {SFName ? <p className="m-0">{SFName}</p> : <p className="m-0">Select File</p>}
                            </div>
                        </div>
                        <p className="m-0">Select or Drag and drop file</p>
                    </div>
                </Col>
                <Col>
                    <div className="SubHeading mb-3">Upload instructions</div>
                    <ol>
                        <li>Do not change the header names in the file.</li>
                        <li>Fill the template with the required Student Ids to deactivate.</li>
                        <li>Student Id should have a length of 10 digits</li>
                        <li>A maximum of 25 Student Ids should be given for deactivation.</li>
                        <li>Please do not refresh the page until the entire operation is completed.</li>
                    </ol>
                </Col>
            </Row>


            {InValidRecords?.length > 0 && <>
                <div className="SubHeading mt-2"> Invalid Records</div>
                <DataTable data={InValidRecords} columns={InvalidColumns} className="NCLDataTable Card mt-2" DisplaySearch={true} Dropdownvalues={["30"]} /> </>}

            {ValidRecords?.length > 0 && <>
                <div className="dflex JSBetween alignitems mt-4">
                    <div className="SubHeading"> Valid Records</div>

                    <div className="dflex gap-3 alignitems">
                        {SFName && ValidRecords.length > 0 && <>
                            <b className="BlinkingText" > Click Confirm to proceed with the Deactivation.</b>
                            <button className="Buttons" onClick={() => SetFConformation(true)} > Confirm Deactivation </button> </>}</div>
                </div>
                <div className="NCLDataTable Card mt-2">
                    <table className="Data-Table">
                        <thead>
                            <tr>
                                <th>S.No</th> <th>Student ID</th> <th>Student Name</th> <th>Grade</th>
                                <th>Section</th> <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ValidRecords?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td> <td>{item.studentId}</td> <td>{item.studentName}</td>
                                    <td>{item.grade}</td> <td>{item.section}</td>
                                    <td> <div className="d-flex justify-content-center">
                                        <RiDeleteBin5Line style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => DeleteValidRecords(item)} />
                                    </div></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>}

            {FConformation &&
                <div className="Model-Open">
                    <div className="Card w-50 Model-Content">
                        <div className="dflex JSBetween" style={{ color: "black", }}>
                            <div></div>
                            <h5 className="MainHeading"> Confirm Deactivation </h5>
                            <div className="CPointer" onClick={() => SetFConformation(false)}> <IoCloseCircleOutline size={20} /></div>
                        </div>
                        <hr className="mt-0" />
                        <div>
                            <p className="mb-0">Are you sure you want to Deactivate students?</p>
                            <p className="text-danger mt-2 mb-0"> Once Deactivated, the student will not be able to login to the application. </p>
                        </div>
                        <div className="dflex gap-3" style={{ justifyContent: "flex-end" }}>
                            <button className="Buttons bg-danger" onClick={() => SetFConformation(false)}> Cancel </button>
                            <button className="Buttons" onClick={() => handleDeactivate()}> GO </button>
                        </div>
                    </div></div>}
        </>
    )
}
export default SBDeactivation;